<template>
    <div class="cache-settings">
        <Toast />
        <h3>Cache</h3>
        <p>Tøm all cache. Dette inkluderer inneholdet som hentet fra CMS-et, som forside, artikler, meny og footer.</p>
        <Button label="Tøm cache" icon="pi pi-trash" severity="danger" :loading="clearing" @click="clearCache" />
    </div>
</template>
<script>
import Button from 'primevue/button';
import Toast from 'primevue/toast';
import { useToast } from 'primevue/usetoast';

function csrfToken() {
    return document.querySelector('meta[name="csrf-token"]').content;
}

export default {
    components: {
        Button,
        Toast,
    },
    setup() {
        return {
            toast: useToast(),
        };
    },
    data() {
        return {
            clearing: false,
        };
    },
    methods: {
        async clearCache() {
            this.clearing = true;

            try {
                const response = await fetch('/api/v1/settings/cache/clear', {
                    method: 'POST',
                    headers: {
                        'X-CSRF-TOKEN': csrfToken(),
                        Accept: 'application/json',
                    },
                });

                if (!response.ok) {
                    throw new Error('request failed');
                }

                this.toast.add({ severity: 'success', summary: 'Tømt', detail: 'Cachen ble tømt.', life: 3000 });
            } catch (error) {
                console.error(error);
                this.toast.add({ severity: 'error', summary: 'Feil', detail: 'Kunne ikke tømme cachen.', life: 3000 });
            } finally {
                this.clearing = false;
            }
        },
    },
};
</script>
<style scoped>
.cache-settings p {
    margin-bottom: 1rem;
}
</style>
